import { UserRole } from '../../../constants/user_types';

export const ALERT_MANAGEMENT_ROLES: UserRole[] = [
  UserRole.ADMIN,
  UserRole.AGRO,
  UserRole.OPERATOR,
];

export const ALERT_LIST_UI = [
  { key: 'name', label: 'Nombre' },
  { key: 'startDate', label: 'Fecha de inicio' },
  { key: 'endDate', label: 'Fecha de fin' },
  { key: 'message', label: 'Límites' },
  { key: 'active', label: 'Estado' },
  { key: 'actions', label: 'Acciones' },
];

export const ALL_ALERTS_LIST_UI = [
  { key: 'name', label: 'Nombre' },
  { key: 'sector', label: 'Sector' },
  { key: 'chart', label: 'Gráfico' },
  { key: 'startDate', label: 'Fecha de inicio' },
  { key: 'endDate', label: 'Fecha de fin' },
  { key: 'message', label: 'Límites' },
  { key: 'active', label: 'Estado' },
  { key: 'actions', label: 'Acciones' },
];

export const formatShortDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};
